import { PermissionGroup } from "@app/auth/services/custom-authentication.service";
import { InstitutionOwner } from "@app/features/master/master-cliente/cliente-grupo-investimento/cliente-grupo-investimento.model";



export class User {
    profileId?: string;
    ddi?: string;
    birthDate?: Date;
    cellNumber?: string;
    cpf?: string;
    documentNumber?: string;
    id?: string;
    internationalPrefix?: string;
    language?: string;
    nationality?: string;
    status?: string;
    login?: string;
    name?: string;
    passport?: string;
    rg?: string;
    type?: string;
    institutionOwners?: InstitutionOwner;
    permissionGroup?: PermissionGroup;
    investmentGroups: any[];
    clients?: any;
    permissionGroups: { id: any; }[];
    fone?: string;
    userSso : any;
    reason:any;
}